
import React from 'react'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import SimpleScores from 'smartstream-widgets/controls/SimpleScores/SimpleScores'

import { withStyles, createStyles } from '@mui/styles'
import { Team } from './types'
import { CompetitorBrand } from "smartstream-widgets/types/competitor"
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme'

const styles = () => createStyles({
  root: {
    width: 'auto'
  },
  scores: {
    fontSize: 11,
    margin: `0px 12px`
  },
  teamName: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    fontSize: 11,
    lineHeight: 1.2,
    overflow: 'hidden',
    width: '100%'
  },
  nameComponent: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '100%',
    whiteSpace: 'nowrap'
  },
  fullNameFallback: {
    overflow: 'hidden',
    position: 'relative',
    width: '100%'
  },
  teamRight: {
    textAlign: 'right'
  },
  teamLeft: {
    textAlign: 'left'
  },
  teamScoreRight: {},
  teamScoreLeft: {},
  teamRecords: {}
})

export function TeamAndRecords(props: Team) {
  const { classes, competitor, scores, showName = true, showRecords = false, teamSide } = props
  const { brand = {} as CompetitorBrand, firstName, secondName, officialName, displayName } = competitor
  const useDisplayName = displayName != null && displayName.length > 0
  const isNameSeparated = firstName && secondName || displayName && displayName.length === 2 && displayName[1]
  const hasRecords = Number.isInteger(scores.leftScore) && Number.isInteger(scores.rightScore)

  return (
    <Grid container
      direction={teamSide === 'right' ? 'row-reverse' : 'row'}
      justifyContent='space-between'
      wrap='nowrap'
      alignItems='center'
      data-testid='team-and-records-container'
      className={classes.root}>
      {showName && <Typography
        className={classes.teamName}
        style={{ color: brand.primaryColor }}>
        {isNameSeparated &&
          <span
            className={`${classes.nameComponent} ${teamSide === 'right' ? classes.teamRight : classes.teamLeft}`}>
            {useDisplayName ? displayName[0] : firstName}
          </span>
        }
        <span
          className={
            `${isNameSeparated ? classes.nameComponent : classes.fullNameFallback} ${teamSide === 'right' ? classes.teamRight : classes.teamLeft}`
          }>
          {
            isNameSeparated ? (useDisplayName ? displayName[1] : secondName) : officialName
          }
        </span>
      </Typography>}
      {
        hasRecords && showRecords &&
        <SimpleScores
          classes={{
            root: classes.scores,
            separator: classes.scoresSeparator,
            teamSide: teamSide === 'right' ? classes.teamScoreRight : classes.teamScoreLeft,
            teamRecords: classes.teamRecords
          }}
          {...scores}
          animationType={'slideUp'}
        />
      }
    </Grid>
  )
}

export default withStyles(styles, { name: 'TeamAndRecords',defaultTheme: getDefaultTheme })(TeamAndRecords)
